export default {
  HOME: 'home',
  ARTICLE: 'article',
  TOPIC: 'topic',
  SEARCH: 'search',
};



// WEBPACK FOOTER //
// ./home/constants/UrlResources.js